import React from 'react';
import { TitleWithNamespace as Title } from 'components/Toolbar/constants';
import Control from 'components/Toolbar/Controls/Control';
import { ControlState } from 'components/Toolbar/Controls/Control/constants';
import { CharStyle } from 'const';
import { IconType } from '../../../Icon/constants';

const CHAR_STYLES = [
  { label: IconType.TOOLBAR_BOLD, style: CharStyle.BOLD, title: Title.FONT_DECORATION_BOLD },
  { label: IconType.TOOLBAR_ITALIC, style: CharStyle.ITALIC, title: Title.FONT_DECORATION_ITALIC },
  { label: IconType.TOOLBAR_UNDERLINE, style: CharStyle.UNDERLINE, title: Title.FONT_DECORATION_UNDERLINE },
];

type Props = {
  activeStyles: CharStyle[];
  onToggle: (style: CharStyle) => void;
  dataTestId?: string;
};

// TODO: convert to the same interface as FontDecoration Control
const CharStyleControl: React.FunctionComponent<Props> = (props) => {
  const {
    activeStyles = [],
    onToggle,
    dataTestId = 'charStyleControl',
  } = props;

  return (
    <>
      {CHAR_STYLES.map((type, index) => (
        <Control
          key={type.label}
          controlState={ControlState}
          onToggle={onToggle.bind(null, type.style)}
          state={activeStyles.includes(type.style) ? ControlState.ACTIVE : ControlState.DEFAULT}
          title={type.title}
          type={type.label}
          dataTestId={`${dataTestId}-control${index}`}
        />
      ))}
    </>
  );
};

export default CharStyleControl;
